import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import { color } from "theme";

import { useBackgroundColor } from "Signups/stateHooks";

export default function IconButton({ icon, label, ...rest }) {
  const { colorVariant } = useBackgroundColor();

  return (
    <Button {...rest}>
      <Content>
        <I className={`fas ${icon}`} $colorVariant={colorVariant} />
        <Label $colorVariant={colorVariant}>{label}</Label>
      </Content>
    </Button>
  );
}

IconButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
};

const Button = styled.button`
  background: hsl(0 0% 100% / 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 6px;
  font-size: 3rem;
  width: 140px;
  height: 120px;
  flex-shrink: 0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 200ms;

  &:hover {
    background-color: hsl(0 0% 100% / 0.25);
  }

  &:focus-within {
    outline: 2px solid hsl(0 0% 100% / 1);
    outline-offset: -2px;
    background-color: hsl(0 0% 100% / 0.25);
  }
`;

const Content = styled.div`
  display: grid;
  place-items: center;
  transition: transform 150ms;

  ${Button}:hover & {
    transform: scale(1.06);
  }
  ${Button}:active & {
    transform: scale(0.98);
  }
`;

const I = styled.i`
  ${color}
`;

const Label = styled.div`
  font-size: 0.9rem;
  line-height: 1rem;
  ${color}
  margin-top: 6px;
  font-weight: 400;
`;